import * as L from 'leaflet';
import Spinner from 'spin';

// TODO -- Is this class needed? Can it be combined with the inheriting class in
// calling code or something simpler? The structure is left over from ReactLeaflet.

const LoadingImageOverlay = L.ImageOverlay.extend({

  /**
   * @override
   */
  onAdd: function (map) {

    // Add the spinner el first
    if (!this._spinnerElement) {
      this._addSpinner(map);
    }

    L.ImageOverlay.prototype.onAdd.apply(this, arguments);
  },

  /**
   * @override
   */
  onRemove: function (map) {
    L.ImageOverlay.prototype.onRemove.apply(this, arguments);
    this._removeSpinner(map);
  },

  /**
   * @override
   */
  _animateZoom: function () {
    L.ImageOverlay.prototype._animateZoom.apply(this, arguments);
  },


  /**
   * @override
   */
  _reset: function () {
    L.ImageOverlay.prototype._reset.apply(this, arguments);

    if (this._spinner) {
      const topLeft = this._map.latLngToLayerPoint(this._bounds.getNorthWest());
      const size = this._map.latLngToLayerPoint(this._bounds.getSouthEast())._subtract(topLeft);

      L.DomUtil.setPosition(this._spinnerElement, topLeft);
      this._spinnerElement.style.width = size.x + 'px';
      this._spinnerElement.style.height = size.y + 'px';
      this._spinner.spin(this._spinnerElement);
    }
  },

  _onImageLoad: function () {
    this._removeSpinner(this._map);
  },

  _addSpinner: function (map) {
    this.on('load', this._onImageLoad);
    this._spinnerElement = L.DomUtil.create('div',
      'leaflet-zoom-hide leaflet-loading-image-spinner');
    map._panes.overlayPane.appendChild(this._spinnerElement);
    this._spinner = new Spinner(this.options.spinnerOpts || {});
  },

  _removeSpinner: function (map) {
    this.off('load', this._onImageLoad);

    // Only remove it if exists, can happen in two different cases:
    // 1. onImageLoad
    // 2. Layer is removed before image loaded
    if (this._spinner) {
      this._spinner.stop();
      this._spinner = null;
      map.getPanes().overlayPane.removeChild(this._spinnerElement);
    }
  }

});

export default LoadingImageOverlay;
